/**
 * Hinweise im Tab Energieausweis, die nur mit dem automatischen Auslesen (reva-idp-energy) einen Sinn haben.
 * Ohne das Recht wird nie ein Energieausweis ausgewertet: Die Werte stammen immer aus der Handeingabe,
 * es gibt weder etwas auszuwählen noch zu ersetzen (#19302 K6-B5/K6-B6).
 */

/** Warnung „mehrere Energieausweise, einen auswählen und auswerten“: nur mit Recht, ≥ 2 Ausweisen und leerer IDP-Schicht. */
export function showMultipleCertificatesWarning(
    certificateCount: number,
    idpLayerEmpty: boolean,
    canUseIdpEnergy: boolean,
): boolean {
    return canUseIdpEnergy && certificateCount >= 2 && idpLayerEmpty;
}

/** Rückfrage vor dem Upload eines weiteren Energieausweises, der die automatisch ausgelesenen Daten ersetzt. */
export function needsReplaceConfirm(alreadyHasCertificate: boolean, canUseIdpEnergy: boolean): boolean {
    return canUseIdpEnergy && alreadyHasCertificate;
}

/**
 * Parameter, deren „Keine Angabe“ (`"empty"`) im Tab Energieausweis ein neues IDP-Ergebnis zurücksetzt: Ein vorab
 * geleerter Wert war keine Entscheidung gegen den jetzt ausgelesenen und würde ihn sonst still verdrängen (#19774).
 */
export function energyCertEmptyKeysToReset(
    energyParams: Record<string, unknown> | null | undefined,
    idpValues: Record<string, unknown>,
): string[] {
    return Object.entries(idpValues)
        .filter(([key, value]) => value != null && value !== "empty" && energyParams?.[key] === "empty")
        .map(([key]) => key);
}
